import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import styles from "./../../assets/scss/custom.module.scss";
import "./../../assets/scss/common.scss";
import "./publicpagination.scss";
import { pagination } from "../../locales/en";
import {
  PAGE_COUNT,
  PAGE_INDEX,
  PAGE_SIZE,
  PAGE_SIZE_OPTIONS
} from "../../utils/constants/appConstants";

const PublicPaginationController = ({
  gotoPage,
  previousPage,
  nextPage,
  canPreviousPage,
  canNextPage,
  pageIndex,
  pageCount,
  onPaginationChange,
  setPageSize,
  pageSize,
  showButtons,
  dataLength
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    gotoPage(PAGE_INDEX);
    onPaginationChange && onPaginationChange(true);
  };

  const getPaginationRange = () => {
    const totalPages = pageCount;
    const currentPage = pageIndex + 1;

    if (isMobile) {
      if (totalPages <= 3) {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
      }

      if (currentPage <= 2) {
        return [1, 2, "...", totalPages];
      }

      if (currentPage >= totalPages - 1) {
        return [1, "...", totalPages - 1, totalPages];
      }

      return [1, "...", totalPages];
    }

    const delta = 2;
    const range = [];
    const rangeWithDots = [];

    let l;

    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        (i >= currentPage - delta && i <= currentPage + delta)
      ) {
        range.push(i);
      }
    }

    for (const i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l > 2) {
          rangeWithDots.push("...");
        }
      }
      rangeWithDots.push(i);
      l = i;
    }

    return rangeWithDots;
  };

  return (
    <div
      className={`${styles.pagiNationBar} mainPagination d-flex justify-content-center align-items-center publicpagination-wrapper`}
    >
      {showButtons ? (
        <>
          <button
            onClick={() => {
              previousPage();
              onPaginationChange && onPaginationChange(true);
            }}
            disabled={!canPreviousPage}
          >
            <FaAngleLeft />
          </button>

          <div className="paginationNumbers d-flex justify-content-center align-items-center">
            {getPaginationRange().map((item, index) => {
              if (item === "...") {
                return (
                  <button key={index} className="page-btn dots" disabled>
                    ...
                  </button>
                );
              }

              return (
                <button
                  key={index}
                  onClick={() => {
                    gotoPage(item - 1);
                    onPaginationChange && onPaginationChange(true);
                  }}
                  className={`page-btn ${item - 1 === pageIndex ? "active" : ""}`}
                >
                  {item}
                </button>
              );
            })}
          </div>

          <button
            onClick={() => {
              nextPage();
              onPaginationChange && onPaginationChange(true);
            }}
            disabled={!canNextPage}
          >
            <FaAngleRight />
          </button>
        </>
      ) : (
        <span className="showArea">
          {pagination?.show}
          <select
            className={styles.selectShowStatus}
            value={pageSize}
            onChange={(e) => handlePageSizeChange(Number(e.target.value))}
            disabled={
              pageCount === PAGE_COUNT &&
              typeof dataLength === "number" &&
              dataLength < PAGE_SIZE
            }
          >
            {PAGE_SIZE_OPTIONS.map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </select>
        </span>
      )}
    </div>
  );
};
PublicPaginationController.propTypes = {
  gotoPage: PropTypes.any,
  previousPage: PropTypes.any,
  nextPage: PropTypes.any,
  canPreviousPage: PropTypes.any,
  canNextPage: PropTypes.any,
  pageIndex: PropTypes.any,
  pageCount: PropTypes.any,
  onPaginationChange: PropTypes.func,
  setPageSize: PropTypes.any,
  pageSize: PropTypes.any,
  showButtons: PropTypes.bool,
  dataLength: PropTypes.number
};

export default PublicPaginationController;
